<template>
  <div class="pb-3" >
    <va-card :title="$t(`weeks-group.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="week.name"
                  :label="$t('weeks-group.forms.nameLabel')"
                  :placeholder="$t('weeks-group.forms.namePlaceholder')"
                  :success="errors.length == 0 && week.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <va-toggle
                v-model="week.active"
                small
                :label="$t('weeks-group.forms.activeLabel')"
              />
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'WeeksGroupAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      week: {
        name: '',
        active: false,
      },
      logo: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.week.name = ''
    if (this.updateData !== null) {
      this.week_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.week_get(this.updateData)
      } else {
        this.week.name = ''
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    week_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          this.week[value] = data[value]
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, active } = this.week
      const self = this
      const updateAll = `update_week_group(_set: {active: false}, where: {id: {_gte: 0}}) {
        affected_rows
      }`
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($name: String!, $active: Boolean, $id: Int!) {
                  ${active === true ? updateAll : ''}
                  update_week_group_by_pk(pk_columns: {id: $id}, _set: {name: $name, active: $active}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($name: String, $active: Boolean) {
                  ${active === true ? updateAll : ''}
                  insert_week_group(objects: {name: $name, active: $active}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            name,
            active,
            id: this.week.id,
          } : {
            name,
            active,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.week.name = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.week.name = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
